import axiosInstance from '../config/axios.js';

const buildParams = ({ fromDate, toDate, userId, page, perPage, ...rest } = {}) => {
  const params = { ...rest };
  if (fromDate) params.from_date = fromDate;
  if (toDate) params.to_date = toDate;
  if (userId) params.user_id = userId;
  if (page) params.page = page;
  if (perPage) params.per_page = perPage;
  return params;
};

const dashboardService = {
  getOverview: async (opts = {}) =>
    (await axiosInstance.get('/dashboard/overview', { params: buildParams(opts) })).data,

  getShipmentRecords: async (opts = {}) =>
    (await axiosInstance.get('/dashboard/shipments/records', { params: buildParams(opts) })).data,

  getPaymentRecords: async (opts = {}) =>
    (await axiosInstance.get('/dashboard/payments/records', { params: buildParams(opts) })).data,

  getAttendanceRecords: async (opts = {}) =>
    (await axiosInstance.get('/dashboard/attendance/records', { params: buildParams(opts) })).data,

  getCommissionRecords: async (opts = {}) =>
    (await axiosInstance.get('/dashboard/commission/records', { params: buildParams(opts) })).data,

  getOnContractRecords: async (opts = {}) =>
    (await axiosInstance.get('/dashboard/on-contracts/records', { params: buildParams(opts) })).data,
};

export default dashboardService;
